<div>
  <h2 mat-dialog-title>{{ header }}</h2>
  <mat-dialog-content>
    <mat-label>{{ message }}</mat-label>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="flex-spacer"></div>
    <button mat-raised-button mat-dialog-close (click)="onNoClick()">ยกเลิก</button>
    <button mat-raised-button *ngIf="!warn" class="submit-button" (click)="onYesClick()">บันทึก</button>
    <button mat-raised-button *ngIf="warn" color="warn" class="submit-button" (click)="onYesClick()">ลบ</button>
  </mat-dialog-actions>
</div>
